module.exports = __webpack_public_path__ + "img/plastic-waste-7617451_1280_thumb.7e4eaa07.jpg";